// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-4052e9a7] {\n  color: #E9A021;\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
